import z from 'zod';

import { CONTROLLING_PARTY_CUSTOM_ROLE_MAX_LENGTH } from '@dealstack/shared/lib/common/business/controllingParty';
import { PersonRelationType } from '@dealstack/shared/lib/generated';
import { EDIT_RELATED_PERSON_FORM_FIELDS } from './types';

export const RelatedPersonFormShape = z
	.object({
		[EDIT_RELATED_PERSON_FORM_FIELDS.relation_type]: z.nativeEnum(PersonRelationType),
		[EDIT_RELATED_PERSON_FORM_FIELDS.relation_id]: z.string(),
		[EDIT_RELATED_PERSON_FORM_FIELDS.create_legal_rep]: z.boolean().optional(),
		[EDIT_RELATED_PERSON_FORM_FIELDS.custom_relation_type]: z
			.string()
			.trim()
			.max(CONTROLLING_PARTY_CUSTOM_ROLE_MAX_LENGTH)
			.optional(),
	})
	// The free-text role is mandatory for OTHER — mirrors the API's rule.
	.superRefine((values, ctx) => {
		if (
			values[EDIT_RELATED_PERSON_FORM_FIELDS.relation_type] === PersonRelationType.OTHER &&
			!values[EDIT_RELATED_PERSON_FORM_FIELDS.custom_relation_type]?.trim()
		) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: [EDIT_RELATED_PERSON_FORM_FIELDS.custom_relation_type],
				message: 'Required',
			});
		}
	});
